<template>
    <v-overlay
        z-index="1"
        absolute
        rounded
        :value="true"
        class="right-side-button"
        :class="{
            'right-side-button': issideright,
            smclass: $breakpoint.xsOnly || btntwo,
            'overlay-radius': $breakpoint.mdAndDown,
            'three-btn': threeBtn
        }"
    >
        <v-btn
            v-if="text !== 'No Text'"
            depressed
            tile
            :small="!isBothFancyVisibleOnDesktop"
            :x-small="isBothFancyVisibleOnDesktop"
            light
            class="grey lighten-2"
        >
            <span v-if="text">{{ text }}</span>
            <slot v-else />
        </v-btn>
    </v-overlay>
</template>
<script>
export default {
    props: {
        text: { type: String, default: "" },
        issideright: { type: String, default: "" },
        threeBtn: { type: Boolean, default: false },
        btntwo: { type: Boolean, default: false }
    }
}
</script>
<style lang="scss" scoped>
.overlay-radius {
    border-radius: 0.4rem;
}
.multibet-custom-overlay {
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0;
    height: 64px;
}
</style>
